import PropTypes from 'prop-types';
import { Modal } from '@bwoty-web/ui-kit';

const OnRequestPopup = ({ labels, hidePopup, isOpen }) => {
  return (
    <Modal
      heading={labels.availableOnRequest}
      isOpen={isOpen}
      onClose={hidePopup}
    >
      <div className="price-matrix-table__on-request-popup">
        <p>{labels.onRequestTextPart1}</p>
        <p>{labels.onRequestTextPart2}</p>
      </div>
    </Modal>
  );
};

OnRequestPopup.propTypes = {
  labels: PropTypes.shape({
    availableOnRequest: PropTypes.string,
    onRequestTextPart1: PropTypes.string,
    onRequestTextPart2: PropTypes.string,
  }).isRequired,
  hidePopup: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default OnRequestPopup;
